import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const IntroSection = () => {
  const { t } = useLanguage();

  return (
    <section 
      id="intro" 
      className="py-24 md:py-32 bg-[#F7F7F5]"
      data-testid="intro-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl"
        >
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl text-[#1A2F23] font-['Playfair_Display'] mb-8"
            data-testid="intro-title"
          >
            {t('intro_title')}
          </h2>
          
          <p className="text-[#5C5C59] text-lg md:text-xl leading-relaxed mb-8">
            {t('intro_text')}
          </p>
          
          <blockquote className="border-l-4 border-[#C5A059] pl-6 py-2">
            <p className="text-[#1A1A1A] text-lg md:text-xl font-['Playfair_Display'] italic leading-relaxed">
              {t('intro_highlight')}
            </p>
          </blockquote>
        </motion.div>
      </div>
    </section>
  );
};

export default IntroSection;
